import { createSlice } from '@reduxjs/toolkit';

export interface PersonalInfoModalSliceState {
  isOpen: boolean;
}

const initialState: PersonalInfoModalSliceState = {
  isOpen: false,
};

const personalInfoModalSlice = createSlice({
  name: 'personalInfoModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export { personalInfoModalSlice };
